import React, {useRef, useState} from "react";
import styles from "./processMapNodeProfile/ProcessMapNodeProfile.module.scss";
import Collapsable from "../../../Componnets/Collapsable/Collapsable";
import NodeProfileWrapper from "../../../Componnets/NodeProfileWrapper/NodeProfileWrapper";

const ProcessMapNodeProfile = ({ graph, index = 0, data = [], title = '', level = '', caseFrequency = '', filters, views, selectedFilter, selectedView, handleSetSelectedFilter, handleSetSelectedView, showNodeProfile, closeNodeProfile}) => {

    const [activeTab, setActiveTab] = useState({next: true});

    const previous = graph.filter(item => item.to === data[index].id).map(item => data.find(i => i.id === item.from));
    const next = graph.filter(item => item.from === data[index].id).map(item => data.find(i => i.id === item.to));

    const handleActiveTab = (param) => {
        if (!activeTab[param]) {
            setActiveTab(prevState => ({ [ param ]: !prevState[ param ] }));
        }
    }

    const activitiesListRef = useRef(null);

    const executeScroll = () => {
        setTimeout(() => {
            activitiesListRef.current.scrollIntoView({behavior: 'smooth'});
        }, 100);
    }

    return (
        <div className={styles.ProcessMapNodeProfile}>
            <NodeProfileWrapper showNodeProfile={showNodeProfile} closeNodeProfile={closeNodeProfile}>
                <div className={styles.topTitle}>
                    <div className={styles.title}>
                        <div>{ title }</div>
                        <div>
                            <span>Lvl { level }</span>
                            <span>Case Frequency : </span>
                            <span>{ caseFrequency }</span>
                        </div>
                    </div>
                </div>
                <div id={"nodeProfileBody"} className={styles.nodeProfileScrollBody}>
                    <div className={styles.views}>
                        {
                            views.map(item => (
                                <div className={`d-flex ${styles.viewCard}`}>
                                    <div className={`d-flex align-items-center justify-content-center ${styles.icon}`}>
                                        { item.icon }
                                    </div>
                                    <div className={`${styles.info}`}>
                                        <div className={styles.title}>
                                            { selectedView?.[item?.value]?.replace("_", " ") }
                                        </div>
                                        <div className={styles.content}>
                                            {
                                                data &&
                                                    data[index][selectedView[item?.value]]?.value
                                            }
                                        </div>
                                        <div className={`d-flex justify-content-between ${styles.items}`}>
                                            {
                                                item.items.map(view => (
                                                    <div
                                                        onClick={() => handleSetSelectedView(item.value, view.value)}
                                                        className={selectedView[item.value] === view.value && styles.active}
                                                    >
                                                        { view.title }
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className={`${styles.filters}`}>
                        <Collapsable executeScroll={executeScroll} title={"Filters"}>
                            {
                                filters.map(filter => (
                                    <div onClick={() => handleSetSelectedFilter(filter, title)} className={`align-items-center justify-content-center ${styles.filter} ${selectedFilter === filter && styles.active}`}>
                                        { filter }
                                    </div>
                                ))
                            }
                            <div className={styles.text}>Cases <span>{selectedFilter}</span> with this activity</div>
                        </Collapsable>
                    </div>
                    <div ref={activitiesListRef} className={styles.activitiesList}>
                        <Collapsable executeScroll={executeScroll} title={"Activities List"}>
                            <ul className={styles.tabs}>
                                <li
                                    onClick={() => handleActiveTab('next')}
                                    className={`${styles.tab} ${styles.Tab} ${activeTab['next'] ? styles.active : ''}`}>
                                    <div className={'d-flex align-items-center'}>
                                        <div className={'ml-1'}>
                                            Next
                                        </div>
                                    </div>
                                </li>
                                <li
                                    onClick={() => handleActiveTab('previous')}
                                    className={`${styles.tab} ${styles.Tab} ${activeTab['previous'] ? styles.active : ''}`}>
                                    <div className={'d-flex align-items-center'}>
                                        <div className={'ml-1'}>
                                            Previous
                                        </div>
                                    </div>
                                </li>
                                <li className={`${styles.presentationSlider}`} role="presentation"></li>
                            </ul>
                            <div className={'mt-3'}>
                                {
                                    activeTab['next'] ?
                                        next.map(item => <div className={styles.activityName}>{ item?.name }</div>) :
                                        previous.map(item => <div className={styles.activityName}>{ item?.name }</div>)
                                }
                            </div>
                        </Collapsable>
                    </div>
                </div>
            </NodeProfileWrapper>
        </div>
    )
}

export default ProcessMapNodeProfile;